import { render, staticRenderFns } from "./MdopEditAbout.vue?vue&type=template&id=25464cb4&scoped=true&"
import script from "./MdopEditAbout.vue?vue&type=script&lang=js&"
export * from "./MdopEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25464cb4",
  null
  
)

export default component.exports